import clsx from 'clsx';
import { useMemo } from 'react';
import { useFirestore } from 'reactfire';
import { useMeasure } from 'react-use';
import { nonUserFacingTags } from '@/config/templates';
import ModalHoc from '@/components/ModalHoc';
import { ButtonV2 as Button } from '@/components/Button';
import EmbedLayout from '@/components/widget/Layout';
import useReportingWidget from '@/hooks/useReportingWidget';
import responsiveUtils from '@/utils/responsive';
import PreviewContainer from '@/components/WidgetPreviewContainer';
import TagList from '../TagList';
import SpreadsheetLink from '../SpreadsheetLink';
import modalStyles from '@/components/ModalHoc/styles.module.scss';
import displayModalStyles from '@/components/ModalHoc/stylesDisplay.module.scss';
import buttonStyles from '@/components/Button/styles.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const SharedWidgetSelectPreviewModal = _ref => {
  var _widget$tags;

  let {
    widget,
    callToAction,
    onSelect
  } = _ref;
  const firestore = useFirestore();
  const {
    status: reportingWidgetstatus,
    data: reportingWidget,
    error: reportingWidgetError
  } = useReportingWidget(firestore, widget || null);
  const [containerEl, {
    width
  }] = useMeasure();
  const isSingleColLayout = useMemo(() => responsiveUtils.isMediumOrSmaller(width), [width]);
  const isTwoColLayout = !isSingleColLayout;
  const showSidebarButtons = isTwoColLayout;
  const showFooterButtons = isSingleColLayout;
  const isLoaded = reportingWidgetstatus === 'success';
  const hasError = reportingWidgetError;
  return /*#__PURE__*/_jsxs("div", {
    /* @ts-ignore */
    ref: containerEl,
    className: clsx(displayModalStyles.container, isTwoColLayout ? displayModalStyles['container--twoCols'] : ''),
    children: [/*#__PURE__*/_jsxs("aside", {
      className: displayModalStyles.sidebar,
      children: [/*#__PURE__*/_jsxs("header", {
        className: displayModalStyles.sidebar__header,
        children: [/*#__PURE__*/_jsx("h5", {
          className: styles.heading,
          children: widget.title
        }), /*#__PURE__*/_jsx("p", {
          className: clsx(styles.description, '-mb-small'),
          children: widget.description
        }), /*#__PURE__*/_jsx(TagList, {
          keyPrefix: `${widget.id}-shared-preview`,
          tags: (_widget$tags = widget.tags) === null || _widget$tags === void 0 ? void 0 : _widget$tags.filter(tag => !nonUserFacingTags.includes(tag)),
          variant: "hashtag"
        }), widget.spreadsheetSrc ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("span", {
            children: "\xA0//\xA0"
          }), /*#__PURE__*/_jsx(SpreadsheetLink, {
            href: widget.spreadsheetSrc
          })]
        }) : /*#__PURE__*/_jsx(_Fragment, {})]
      }), /*#__PURE__*/_jsx("div", {
        className: displayModalStyles.sidebar__main
      }), showSidebarButtons && /*#__PURE__*/_jsx(Footer, {
        callToAction: callToAction,
        onSelect: () => onSelect(widget)
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: clsx(displayModalStyles.main, styles.main),
      children: [hasError ? /*#__PURE__*/_jsx("span", {
        children: "Please reload and try again"
      }) : /*#__PURE__*/_jsx(_Fragment, {}), !hasError && !isLoaded ? /*#__PURE__*/_jsx("div", {
        className: styles.loader,
        children: /*#__PURE__*/_jsx("span", {
          className: styles.loading,
          children: "Loading"
        })
      }) : /*#__PURE__*/_jsx(_Fragment, {}), !hasError && isLoaded && reportingWidget ? /*#__PURE__*/_jsx(PreviewContainer, {
        defaultZoomLevel: 80,
        children: /*#__PURE__*/_jsx(EmbedLayout, {
          widgetId: widget.id || '',
          reportingWidgetId: reportingWidget.id || '',
          elementId: widget.elementId,
          config: widget.config,
          sections: widget.sections || {},
          subscriptionActive: widget.subscriptionActive
        })
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    }), showFooterButtons && /*#__PURE__*/_jsx(Footer, {
      callToAction: callToAction,
      onSelect: () => onSelect(widget)
    })]
  });
};

const Footer = _ref2 => {
  let {
    onSelect,
    callToAction = 'Use Template'
  } = _ref2;
  return /*#__PURE__*/_jsxs("footer", {
    className: displayModalStyles.footer,
    children: [/*#__PURE__*/_jsx("span", {
      className: clsx(buttonStyles['button--text'], '-c-gray60'),
      "data-modal": "trigger-close",
      children: "Close"
    }), /*#__PURE__*/_jsx(Button, {
      onClick: onSelect,
      size: "large",
      variant: "primary",
      "data-modal": "trigger-close",
      children: callToAction
    })]
  });
};

export default ModalHoc(SharedWidgetSelectPreviewModal, {
  modalClass: modalStyles['container--big'],
  overlayclass: modalStyles['overlay--high']
});